/** Outline glyphs matching Claude's Tool permissions settings (Allow / Ask / Block). */
import styles from "./ToolPermissionIcon.module.css";
export type ToolPermission = "allow" | "ask" | "block";

const LABELS: Record<ToolPermission, string> = { allow: "Allow", ask: "Ask", block: "Block" };

export default function ToolPermissionIcon({ kind, className }: { kind: ToolPermission; className?: string }) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={[styles.icon, className].filter(Boolean).join(" ")}
      data-permission={kind}
    >
      {kind === "allow" && (
        <>
          <circle cx="12" cy="12" r="10" />
          <path d="m9 12 2 2 4-4" />
        </>
      )}
      {kind === "ask" && (
        <>
          <path d="M18 11V6a2 2 0 0 0-4 0" />
          <path d="M14 10V4a2 2 0 0 0-4 0v2" />
          <path d="M10 10.5V6a2 2 0 0 0-4 0v8" />
          <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15" />
        </>
      )}
      {kind === "block" && (
        <>
          <circle cx="12" cy="12" r="10" />
          <path d="m4.9 4.9 14.2 14.2" />
        </>
      )}
    </svg>
  );
}

/** Icon plus its word, e.g. "(✓) allow", for inline use in sentences. */
export function ToolPermissionLabel({ kind, className, lowercase }: { kind: ToolPermission; className?: string; lowercase?: boolean }) {
  return (
    <span className={className}>
      <ToolPermissionIcon kind={kind} />
      {lowercase ? LABELS[kind].toLowerCase() : LABELS[kind]}
    </span>
  );
}
